import { QueryClient } from '@tanstack/react-query';

import { getWorkspaceScopeKey, subscribeActiveTenant } from './active-tenant';

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 30 * 60 * 1000,
        refetchOnWindowFocus: true,
        retry: false,
        staleTime: 0,
      },
    },
  });
}

/**
 * Drops every cached response when the signed-in user or the active organization changes.
 * Several caches (notifications, connections, connector definitions) are keyed without the
 * tenant, so without this the next account or organization would briefly see the previous one.
 */
export function bindQueryClientToWorkspaceScope(
  client: QueryClient,
  onScopeChange?: () => void
): () => void {
  let current = getWorkspaceScopeKey();
  return subscribeActiveTenant(() => {
    const next = getWorkspaceScopeKey();
    if (next === current) return;
    const hadUser = !current.startsWith(':');
    current = next;
    if (!hadUser) return;
    onScopeChange?.();
    client.getMutationCache().clear();
    void client.cancelQueries().then(() => client.resetQueries());
    client.removeQueries({ type: 'inactive' });
  });
}
